import React, { ReactNode } from 'react';
import { AEMComponentRendererProps, TransformedNode } from '@msc-b2c/interfaces/interfaces';
import { createAemRegistry, useEditorEvents } from '@msc-b2c/shared-utils';
import AEMComponentPortal from './AEMComponentPortal';

const defaultChildrenTransformer = (nodes: TransformedNode[]): TransformedNode[] => nodes;
const defaultPropertiesTransformer = () => ({});

export const render = ({ registry }: any, node: TransformedNode, i: number): ReactNode => {
  const AEMComponent = registry.getComponent(node.type);
  const key = `${node.type}-${i}`;

  const transformedChildren = defaultChildrenTransformer(node.nodes);
  const childrenComponents = transformedChildren.map(render.bind(null, { registry }));
  if (AEMComponent) {
    const { transformProperties = defaultPropertiesTransformer } = AEMComponent;

    const props = {
      ...node.properties,
      ...transformProperties(node),
    };
    return (
      <AEMComponentPortal
        key={`portal-${key}`}
        selector={props?.dataComponentName}
      >
        <AEMComponent
          key={key}
          {...props}
          registry={registry}
        >
          {childrenComponents}
        </AEMComponent>
      </AEMComponentPortal>
    );
  }

  return childrenComponents;
};

export const AEMComponentRenderer: React.FC<AEMComponentRendererProps> = ({
  aemDataRoot,
  wrappers,
}: AEMComponentRendererProps) => {
  useEditorEvents();
  if (aemDataRoot) {
    const registry = createAemRegistry(false, wrappers);
    const { type = 'default-root', nodes = [], properties = {} } = aemDataRoot;
    const RootElement: any = registry.getComponent(type);

    const transformedChildren = defaultChildrenTransformer(nodes);
    if (RootElement) {
      return (
        <RootElement {...properties}>
          <>{transformedChildren.map(render.bind(null, { registry }))}</>
        </RootElement>
      );
    } else {
      return <>{transformedChildren.map(render.bind(null, { registry }))}</>;
    }
  }

  return null;
};

AEMComponentRenderer.displayName = 'AemRenderer';
